
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

  width: 100%;

  flex-shrink: 1
}

.card {

  border-radius: 1rem;

  background-color: var(--performance-light-white);

  padding-left: 1.5rem;

  padding-right: 1.5rem;

  padding-top: 1.5rem;

  padding-bottom: 1.5rem;

  color: var(--performance-light-blue)
}

@media (min-width: 768px) {

  .card {

    padding-left: 3rem;

    padding-right: 3rem
  }

  .card {

    padding-top: 2rem;

    padding-bottom: 2rem
  }
}

.card-content-wrapper {

  display: grid;

  grid-template-columns: 6fr 4fr
}

.info {

  grid-column: span 2 / span 2;

  grid-column-start: 1;

  margin-right: 1rem
}

@media (min-width: 480px) {

  .info {

    grid-column: span 1 / span 1
  }
}

@media (min-width: 768px) {

  .info {

    margin-right: 2rem
  }
}

.card-eyebrow {

  font-size: var(--fs-xs);

  line-height: var(--lh-xs);

  text-transform: uppercase
}

.card-title {

  font-size: var(--fs-lg);

  line-height: var(--lh-lg)
}

@media (min-width: 768px) {

  .card-title {

    font-size: var(--fs-xl);

    line-height: var(--lh-xl)
  }
}

.card-indicators {

  grid-column: span 2 / span 2;

  grid-column-start: 1;

  align-self: center
}

@media (min-width: 480px) {

  .card-indicators {

    grid-column: span 1 / span 1
  }

  .card-indicators {

    grid-column-start: 2
  }
}

.card-indicators .indicator:first-child {

  border-top-width: 1px
}

.indicator {

  display: flex;

  align-items: center;

  justify-content: space-between;

  border-width: 0px;

  border-bottom-width: 1px;

  border-style: solid;

  border-color: var(--blue-responsible-lighten-3);

  padding: 0.75rem;

  font-size: var(--fs-sm);

  line-height: var(--lh-sm)
}
`;